import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utils/lib/utils';

const EmptyState = React.forwardRef(({ title, description, action, icon: Icon, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn('flex min-h-[400px] flex-col items-center justify-center rounded-md border border-dashed p-8 text-center animate-in fade-in-50', className)}
      {...props}
    >
      {Icon && (
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-muted">
          <Icon className="h-10 w-10" />
        </div>
      )}
      <div className="mt-6">
        {title && <h3 className="text-2xl font-semibold">{title}</h3>}
        {description && (
          <p className="mt-2 text-sm text-muted-foreground">{description}</p>
        )}
        {action && <div className="mt-6">{action}</div>}
      </div>
    </div>
  );
});

EmptyState.displayName = 'EmptyState';

EmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
  icon: PropTypes.elementType,
  className: PropTypes.string,
};

export { EmptyState }; 